import { useAtom } from 'jotai';
import { reservationScheduleRefetchAtom } from './ReservationScheduleRefetchAtom';

export const useConfigReservationScheduleRefetchNeeded = () => {
    return useAtom(reservationScheduleRefetchAtom);
};
